App.SmNumeralComponent = Em.Component.extend
  tagName: 'span'
  classNames: [ 'sm-numeral' ]

  ###
  # Props
  ###
  value: null
  format: '0,0'
  animated: false
  animationDuration: 100
  animationEasing:  'easeOutQuint'

  ###
  # Рисует значение
  ###
  displayValue: (value) ->
    return if (@get('isDestroyed') or @get('isDestroying'))
    return unless @$()?

    formatted = numeral(value).format(@get('format'))
    @$().text(formatted)
    @set('animatedValue', value)

  animatedValue: 0

  onValueChanged: (->
    return unless @$()?

    animated = @get('animated')
    value    = @get('value')

    if not animated
      @displayValue(value)
    else
      do @get('debouncedAnimate')
  ).observes('value').on('didInsertElement')

  ###
  # debounce-версия функции animate
  ###
  debouncedAnimate: (->
    _.debounce(@animateValue.bind(@), @get('animationDuration'), {
      # leading:  true
      trailing: true # очень важно! Ember.run.debounce не позволяет такое!
    })
  ).property('animationDuration')

  animateValue: ->
    was    = @get('animatedValue')
    become = @get('value')

    Em.$({v: was}).animate {v: become},
      duration: @get('animationDuration')
      easing:   @get('animationEasing')
      queue: false
      step: @displayValue.bind(@)
